import {
  CustomButton,
  CustomInputSelect,
  CustomTextInput,
} from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { IAddressFormMeta } from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/clientAddress/AddressMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';

type Props = {
  onSubmit: any,
  meta: IAddressFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
};

const AddressFormUI = ({ meta, onSubmit, isSubmitting, isLoading }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box w={'100%'} as={'form'} onSubmit={handleSubmit(onSubmit)}>
      <CC.Grid
        templateColumns={{
          base: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
          lg: 'repeat(5, 1fr)',
        }}
        gap={5}
        mb={5}
        py={5}
      >
        <CustomFormControl
          label={meta.addressType.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.addressType.name]}
        >
          <CustomInputSelect
            meta={meta.addressType}
            register={register(meta.addressType.name)}
            hasError={errors[meta.addressType.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.address.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.address.name]}
        >
          <CustomTextInput
            meta={meta.address}
            register={register(meta.address.name)}
            hasError={errors[meta.address.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.city.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.city.name]}
        >
          <CustomInputSelect
            meta={meta.city}
            register={register(meta.city.name)}
            hasError={errors[meta.city.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.street.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.street.name]}
        >
          <CustomTextInput
            meta={meta.street}
            register={register(meta.street.name)}
            hasError={errors[meta.street.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.postalCode.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.postalCode.name]}
        >
          <CustomTextInput
            meta={meta.postalCode}
            register={register(meta.postalCode.name)}
            hasError={errors[meta.postalCode.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.zone.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.zone.name]}
        >
          <CustomTextInput
            meta={meta.zone}
            register={register(meta.zone.name)}
            hasError={errors[meta.zone.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.state.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.state.name]}
        >
          <CustomTextInput
            meta={meta.state}
            register={register(meta.state.name)}
            hasError={errors[meta.state.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.phone1.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.phone1.name]}
        >
          <CustomTextInput
            meta={meta.phone1}
            register={register(meta.phone1.name)}
            hasError={errors[meta.phone1.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.phone2.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.phone2.name]}
        >
          <CustomTextInput
            meta={meta.phone2}
            register={register(meta.phone2.name)}
            hasError={errors[meta.phone2.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.fax.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.fax.name]}
        >
          <CustomTextInput
            meta={meta.fax}
            register={register(meta.fax.name)}
            hasError={errors[meta.fax.name]}
          />
        </CustomFormControl>
      </CC.Grid>

      <CC.SimpleGrid
        mb={10}
        columns={{ base: 1, md: 1, lg: 2 }}
        spacing={{ base: 5, lg: 8 }}
      >
        <CC.Box shadow={"md"}
         p={5}>
          <CC.Heading as="h3" size={'md'} fontWeight="normal" mb={3}>
            Premier contact
          </CC.Heading>
          <CC.Stack gap={3}>
            <CustomFormControl
              label={meta.firstContactFirstname.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.firstContactFirstname.name]}
            >
              <CustomTextInput
                meta={meta.firstContactFirstname}
                register={register(meta.firstContactFirstname.name)}
                hasError={errors[meta.firstContactFirstname.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.firstContactLastname.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.firstContactLastname.name]}
            >
              <CustomTextInput
                meta={meta.firstContactLastname}
                register={register(meta.firstContactLastname.name)}
                hasError={errors[meta.firstContactLastname.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.firstContactFunction.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.firstContactFunction.name]}
            >
              <CustomTextInput
                meta={meta.firstContactFunction}
                register={register(meta.firstContactFunction.name)}
                hasError={errors[meta.firstContactFunction.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.firstContactPhone.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.firstContactPhone.name]}
            >
              <CustomTextInput
                meta={meta.firstContactPhone}
                register={register(meta.firstContactPhone.name)}
                hasError={errors[meta.firstContactPhone.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.firstContactEmail.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.firstContactEmail.name]}
            >
              <CustomTextInput
                meta={meta.firstContactEmail}
                register={register(meta.firstContactEmail.name)}
                hasError={errors[meta.firstContactEmail.name]}
              />
            </CustomFormControl>
          </CC.Stack>
        </CC.Box>

        <CC.Box shadow={"md"}
         p={5}>
          <CC.Heading
            as="h3"
            size={'md'}
            w="100%"
            textAlign={'left'}
            fontWeight="normal"
            mb={3}
          >
            Second contact
          </CC.Heading>
          <CC.Stack gap={3}>
            <CustomFormControl
              label={meta.secondContactFirstname.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.secondContactFirstname.name]}
            >
              <CustomTextInput
                meta={meta.secondContactFirstname}
                register={register(meta.secondContactFirstname.name)}
                hasError={errors[meta.secondContactFirstname.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.secondContactLastname.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.secondContactLastname.name]}
            >
              <CustomTextInput
                meta={meta.secondContactLastname}
                register={register(meta.secondContactLastname.name)}
                hasError={errors[meta.secondContactLastname.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.secondContactFunction.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.secondContactFunction.name]}
            >
              <CustomTextInput
                meta={meta.secondContactFunction}
                register={register(meta.secondContactFunction.name)}
                hasError={errors[meta.secondContactFunction.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.secondContactPhone.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.secondContactPhone.name]}
            >
              <CustomTextInput
                meta={meta.secondContactPhone}
                register={register(meta.secondContactPhone.name)}
                hasError={errors[meta.secondContactPhone.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.secondContactEmail.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.secondContactEmail.name]}
            >
              <CustomTextInput
                meta={meta.secondContactEmail}
                register={register(meta.secondContactEmail.name)}
                hasError={errors[meta.secondContactEmail.name]}
              />
            </CustomFormControl>
          </CC.Stack>
        </CC.Box>
      </CC.SimpleGrid>

      <CC.HStack my={6} justifyContent={'flex-end'}>
        <CustomButton isLoading={isSubmitting} type={'submit'}>
          <FaSave style={{ marginRight: '10px' }} /> Enregistrer
        </CustomButton>
      </CC.HStack>
    </CC.Box>
  );
};

export default AddressFormUI;
